import Swiper from 'swiper';
import 'swiper/css';

export function initSdgSlider() {
    const sliderElements = document.querySelectorAll('.sdg-slider');
    
    sliderElements.forEach((sliderElement) => {
        let swiperInstance = null;
        
        const initSwiper = () => {
            if (window.innerWidth < 768 && !swiperInstance) {
                swiperInstance = new Swiper(sliderElement, {
                    slidesPerView: 1.3,
                    
                    loop: false,
                });
            } else if (window.innerWidth >= 768 && swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };
        
        initSwiper();
        
        window.addEventListener('resize', initSwiper);
    });
}
